




import RouteView from "@/components/layouts/layout/RouteView.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
@Component(
{

})
export default class Admin extends Vue
{
   
}
